export default __webpack_public_path__ + "static/media/rankpage-top1.e0198041.svg";